// extracted by mini-css-extract-plugin
module.exports = {"link":"arrow_link__I_XhB"};